import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import styles from './list.scss.js';
let counter = 0;
/**
 * @element cipublic-list
 */
export class List extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * The link-list background color.
         */
        this.background = 'alternate';
        /**
         * Set columns for multicol spread.
         */
        this.columns = 1;
        /**
         * ID to associate the label with the element.
         */
        this._id = ++counter;
        /**
         * Inline heading.
         */
        this.inlineHeading = false;
        /**
         * The list display orientation.
         */
        this.layout = 'vertical';
        /**
         * Constructor name.
         */
        this._name = 'list';
        /**
         * Indicate if the list should be nested inside a navigation element.
         */
        this.nav = false;
        /**
         * Indicate if the list styles should be the default look-and-feel.
         */
        this.unstyled = false;
        /**
         * Indicate if the list is ordered or unordered.
         */
        this.type = 'unordered';
        /**
         * Tag variant.
         */
        this.variant = 'default';
    }
    static get styles() {
        return [styles];
    }
    getMax() {
        if (this.grouping >= this.initialChildren.length) {
            return 1;
        }
        else if (this.grouping !== 2 && this.initialChildren.length % this.grouping === 0) {
            return this.grouping;
        }
        else if (this.initialChildren.length % 2 === 0) {
            return this.initialChildren.length / 2;
        }
        else {
            return (this.initialChildren.length + 1) / 2;
        }
    }
    renderItems() {
        var _a;
        if (this.grouping > 1) {
            const elementArrays = Array.from({ length: this.getMax() }, () => { var _a; return (_a = this.initialChildren) === null || _a === void 0 ? void 0 : _a.splice(0, this.grouping); });
            return html `${elementArrays === null || elementArrays === void 0 ? void 0 : elementArrays.map((elements) => html `<li>${elements === null || elements === void 0 ? void 0 : elements.map((child) => html `${child}`)}</li>`)}`;
        }
        return html `${(_a = this.initialChildren) === null || _a === void 0 ? void 0 : _a.map((child) => html `<li>${child}</li>`)}`;
    }
    renderList() {
        return this.type === 'ordered'
            ? html `<ol>${this.renderItems()}</ol>`
            : html `<ul>${this.renderItems()}</ul>`;
    }
    connectedCallback() {
        super.connectedCallback();
        // gives enough time for children to be defined
        this.initialChildren = Array.from(this.children).filter((element) => {
            return !(element.nodeName === 'SLOT') && !element.slot;
        });
    }
    updated(changedProperties) {
        var _a, _b, _c, _d;
        super.updated(changedProperties);
        if (changedProperties.has('background')) {
            if (this.background === 'dark') {
                (_a = this.querySelector('*')) === null || _a === void 0 ? void 0 : _a.classList.add('inverted');
                (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('*').forEach((element) => {
                    if (element.tagName.includes('-')) {
                        element.classList.add('inverted');
                    }
                });
            }
            else {
                (_c = this.querySelector('*')) === null || _c === void 0 ? void 0 : _c.classList.remove('inverted');
                (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelectorAll('*').forEach((element) => {
                    if (element.tagName.includes('-')) {
                        element.classList.remove('inverted');
                    }
                });
            }
        }
        this.style.setProperty('--link-list-columns', `${this.columns}`);
    }
    render() {
        const idName = `${this._name}-${this._id}`;
        return html `<div class="parent">${this.nav
            ? html `<slot></slot><slot name="heading" id="${idName}"></slot><slot name="content"></slot><nav aria-describedby="${idName}">${this.renderList()}</nav>`
            : html `<slot></slot><slot name="heading" id="${idName}"></slot><slot name="content"></slot>${this.renderList()}`}</div>`;
    }
}
__decorate([
    property({ reflect: true })
], List.prototype, "background", void 0);
__decorate([
    property({ reflect: true, type: Number })
], List.prototype, "columns", void 0);
__decorate([
    property({ reflect: true, type: Number })
], List.prototype, "grouping", void 0);
__decorate([
    property({ reflect: true, attribute: 'inline-heading', type: Boolean })
], List.prototype, "inlineHeading", void 0);
__decorate([
    property({ reflect: true })
], List.prototype, "layout", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], List.prototype, "nav", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], List.prototype, "unstyled", void 0);
__decorate([
    property({ reflect: true })
], List.prototype, "type", void 0);
__decorate([
    property({ reflect: true })
], List.prototype, "variant", void 0);
//# sourceMappingURL=list.js.map